module.exports = __webpack_public_path__ + "img/divider-dynamic.febadb16.svg";